import FootFallCaseStudyImage from '@static/images/figures/footfall-case-study.webp';
import LoRaCaseStudyImage from '@static/images/figures/lora-case-study.webp';

import BLEIcon from '@images/icons/technologies/ble.svg';
import UWBIcon from '@images/icons/technologies/uwb.svg';
import LoRaIcon from '@images/icons/technologies/lora.svg';
import RFIDIcon from '@images/icons/technologies/rfid.svg';
import GPSIcon from '@images/icons/technologies/gps.svg';
import zigBeeIcon from '@images/icons/technologies/zig-bee.svg';

import { PageUrls } from '@utils/constants/PageUrls';
import { SPARK_YOUTUBE_VIDEO } from './LocationAssetsTrackingData';


export const caseStudies = [
	{
		media: FootFallCaseStudyImage,
		hasVideo: false,
		leadingIcon: BLEIcon,
		title: 'BLE',
		description:
			'It is a paradigm similar to the traditional data center setup in which you are given machines and are in charge of maintaining them remotely. You supply your own licenses, software, and services to the servers in this approach, while the cloud provider is only responsible for the hardware, the network, storage and virtualization of your assigned machines.',
		link: PageUrls.FOOTFALL_CASE_STUDY,
	},
	{
		media: SPARK_YOUTUBE_VIDEO,
		hasVideo: true,
		leadingIcon: UWBIcon,
		title: 'UWB',
		description:
			'UltraWide Band is a short-range wireless communication protocol operating via radio waves. What is extraordinary about this solution, UWB could be extremely precise and accurate when it comes to data, at the same time requiring minimal power. We used UWB protocol for the indoor positioning system that we created for management in agro-industries.',
		link: PageUrls.SPARK_CASE_STUDY,
	},
	{
		media: LoRaCaseStudyImage,
		hasVideo: false,
		leadingIcon: LoRaIcon,
		title: 'LoraWAN',
		description:
			'Long Range, low-power, wide area networking protocol. Wireless technology helps to secure data transmission for M2M and IoT applications. LoRa can be used to connect sensors, gateways, devices, but also people or animals. This protocol helps in the quick setup of public or private IoT networks anywhere using hardware and software. We used LoRaWAN protocol for smart parking sensors for SMARTFACTOR.',
		link: PageUrls.SMARTFACTOR_CASE_STUDY,
	},
];

export const weAlsoWorkWith = [
	{
		title: 'RFID',
		icon: RFIDIcon,
		description: 'A technology that uses a small microchip tag attached to an object to identify and collect data about it automatically. A built-in antenna on the RFID tag connects it to remote scanning equipment, which reads the data. The corporate application software that stores the data receives the data after it has been transferred from the scanning device. Each RFID tag has a specific identification number of its own.',
	},
	{
		title: 'GPS',
		icon: GPSIcon,
		description: 'A widely used but not publicly accessible satellite-based navigation system is called the Global Positioning System (GPS). At least 24 GPS satellites continuously orbit the Earth, each sending out a signal picked up by GPS devices and used to determine its precise location. The time it takes to receive the signal is how GPS calculates the distance.',
	},
	{
		title: 'ZigBee',
		icon: zigBeeIcon,
		description: 'A wireless network\u2019s data transmission protocol. It performs similarly to Wi-Fi, it uses less power, has slower bit rates (up to 250 kbps), and has ranges of up to 100 meters. ZigBee uses two-way communication. Any device can transmit or receive a signal, and some can even forward it. Instant access is one of its benefits, which is why it is so frequently utilized in devices like motion sensors.',
	},
];